var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlassSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.0006 6.92762C13.0006 8.36179 12.535 9.68659 11.7506 10.7614L15.707 14.7202C16.0977 15.1108 16.0977 15.7451 15.707 16.1356C15.3164 16.5262 14.682 16.5262 14.2913 16.1356L10.3349 12.1769C9.25983 12.9642 7.93476 13.4267 6.50032 13.4267C2.90952 13.4267 0 10.5177 0 6.92762C0 3.33752 2.90952 0.428574 6.50032 0.428574C10.0911 0.428574 13.0006 3.33752 13.0006 6.92762ZM6.50032 11.427C8.98481 11.427 11.0005 9.41163 11.0005 6.92762C11.0005 4.44361 8.98481 2.42828 6.50032 2.42828C4.01582 2.42828 2.0001 4.44361 2.0001 6.92762C2.0001 9.41163 4.01582 11.427 6.50032 11.427Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassSolid);
export default __webpack_public_path__ + "static/media/magnifying-glass-solid.6d7a9ecf8127905480791bdf71f43dcc.svg";
export { ForwardRef as ReactComponent };